import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { PoolID } from '~src/settings/dataconnect-settings/sections/types/PoolID';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IRefreshBaseImageParams {
  poolId: PoolID;
  clusterId: string;
}

export interface IRefreshBaseImageResult extends IResult {
  success?: {
    poolId: PoolID;
    displayName?: string;
    status: string;
    clusterId: string;
  };
  siteId?: string;
  error?: BaasEdgePoolError;
}

export class RefreshBaseImageRequest extends Request<IRefreshBaseImageParams, IRefreshBaseImageResult> {
  constructor(params: IRefreshBaseImageParams) {
    super('refreshBaseImage', params);
  }
}
